<template>
  <div class="achievements">
    <h2 class="achievements__title">{{messages?.AchivmentList}}</h2>
    <div class="achievements-items" :class="size">
      <AchievementsItem v-for="item in sortedAchivment" :result="item"/>
    </div>
<!--    <button type="button" class="achievements__button">
      Показать еще
    </button>-->
  </div>
</template>

<script>
export default {
  name: 'Achievements',
  props: {
    result: {
      type: Object,
      default: {},
    },
    size:{
      type: String,
      default: "smoll",
    },
    messages:{
      type: Object,
      default: {},
    }
  },
  computed: {
    sortedAchivment() {
      return this.result.sort(function (a, b) {
        if (a.count < b.count) {
          return 1;
        }
        if (a.count > b.count) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        return 0;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.achievements {
  &__title{
    margin: 0 0 45px;
  }
  &__button{
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    cursor: pointer;
    height: 50px;
    border: 1px solid #D8DCDE;
    border-radius: 6px;
    width: 100%;
    background-color: transparent;
    margin-top: 39px;
  }
}
.achievements-items {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 31px;
  @include tablet{
    grid-template-columns: repeat(2, 1fr);
  }
  @include mobile{
    grid-template-columns: repeat(1, 1fr);
  }
  &.smoll {
    grid-template-columns: repeat(3, 1fr);

    @include desktopSm{
      grid-template-columns: repeat(2, 1fr);
    }
    @include tablet{
      grid-template-columns: repeat(2, 1fr);
    }
    @include mobile{
      grid-template-columns: repeat(1, 1fr);
    }
  }
}
</style>